import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import REMOVE_FROM_SHOPPING_LIST from '../operations/mutations/remove-from-shopping-list.js';
import { wishlistCountVar } from '../utils/wishlist-count-var.js';

const useRemoveFromShoppinglist = ({ onError , onCompleted  })=>{
    const [hasError, setHasError] = React.useState(false);
    const [mutation, { data: data1 , loading , error  }] = useMutation(REMOVE_FROM_SHOPPING_LIST, {
        onError () {
            onError === null || onError === void 0 ? void 0 : onError();
        },
        context: {
            // TODO: Make use of the locale property from useIntl once BE supports this.
            // For now We need to pass this with a hardcoded value of 'en', because the BE is unable to handle values like en-GB.
            // https://jira.grandvision.global/browse/MACC-15068
            forwardHeaders: {
                'Accept-Language': 'en'
            }
        },
        refetchQueries: [
            'GetShoppingListCount',
            'GetMyWishlistId',
            'GetMyWishlist'
        ]
    });
    const handleOnCompleted = React.useCallback((data)=>{
        if (data.removeFromShoppinglist.__typename === 'RemoveFromShoppinglistFailureResponse') {
            onError === null || onError === void 0 ? void 0 : onError();
        } else {
            if ((data === null || data === void 0 ? void 0 : data.removeFromShoppinglist.__typename) === 'RemoveFromShoppinglistSuccessResponse') {
                var _length;
                /*
            Update the wishlist count to reflect the new amount of items in the wishlist.
            Otherwise the wishlist count will only be updated after a page refresh. This var is shared
            between wish list components and the wish list icon in the header to display the correct
            amount of items in the wishlist and keep the value synchronized after adding and removing items.
          */ wishlistCountVar((_length = data.removeFromShoppinglist.result.items.length) !== null && _length !== void 0 ? _length : null);
            }
        }
        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(data);
    }, [
        onCompleted,
        onError
    ]);
    const removeFromShoppinglist = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(productSkus, shoppinglistId) {
            try {
                if (shoppinglistId) {
                    const { data  } = yield mutation({
                        variables: {
                            input: {
                                productSkus,
                                shoppinglistId
                            }
                        }
                    });
                    if (data) {
                        handleOnCompleted(data);
                    }
                }
            } catch (e) {
                setHasError(true);
                console.error('Error while removing a wishlist item from the shopping list', e);
            }
        });
        return function(productSkus, shoppinglistId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleOnCompleted,
        mutation
    ]);
    var ref, ref1;
    return {
        removeFromShoppinglist,
        loading,
        error: (ref1 = (ref = error !== null && error !== void 0 ? error : hasError) !== null && ref !== void 0 ? ref : (data1 === null || data1 === void 0 ? void 0 : data1.removeFromShoppinglist.__typename) === 'RemoveFromShoppinglistFailureResponse') !== null && ref1 !== void 0 ? ref1 : null
    };
};

export { useRemoveFromShoppinglist };
//# sourceMappingURL=use-remove-from-shopping-list.js.map
